export default function emailSubscription(state = [], action) {
  switch (action.type) {
    case 'SET_EMAIL_SUBSCRIPTION':
      return [...state].concat(action.payload)
    case 'RECEIVE_EMAIL_SUBSCRIPTION':
      return [...state].concat(action.payload)
    default:
      return state
  }
}

export function getSubscriptionByInterest(state, interest) {
  return state.find(subscription => subscription.interest === interest)
}
